import React from 'react';
import { Row, Col } from 'antd';
import { Percentage } from '@/core/domain/owas-report';
import * as S from './styles';

interface PercentageBarRiskProps {
	percentage: Percentage[];
}

export function PercentageBarRisk({ percentage = [] }: Readonly<PercentageBarRiskProps>): JSX.Element {
	function getPercentageValue(number?: number): string {
		return !!number ? `${Math.round(number)}%` : '';
	}

	return (
		<div>
			<Row justify="center" align="middle">
				<Col span={24}>
					<S.StyledPercentageDiv>
						<S.CategoryOne percentage={percentage[0]?.percentage}>
							<strong>{getPercentageValue(percentage[0]?.percentage)}</strong>
						</S.CategoryOne>
						<S.CategoryTwo percentage={percentage[1]?.percentage}>
							<strong>{getPercentageValue(percentage[1]?.percentage)}</strong>
						</S.CategoryTwo>
						<S.CategoryThree percentage={percentage[2]?.percentage}>
							<strong>{getPercentageValue(percentage[2]?.percentage)}</strong>
						</S.CategoryThree>
						<S.CategoryFour percentage={percentage[3]?.percentage}>
							<strong>{getPercentageValue(percentage[3]?.percentage)}</strong>
						</S.CategoryFour>
					</S.StyledPercentageDiv>
				</Col>
			</Row>
		</div>
	);
}
